import React from 'react';
import { MenuItem } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MedisanteDevice } from '../../../Device/types';
import { devicesInCSVFormat } from '../../config';
import DownloadIcon from '@material-ui/icons/SaveAlt';

const useStyes = makeStyles((theme: Theme) => ({
  btn: {
    display: 'flex',
    padding: theme.spacing(0.5, 2),
    minHeight: 48,
    width: '100%',
    color: 'inherit',
    alignItems: 'center',
  },
  menu: {
    padding: 0,
  },
  icon: {
    paddingRight: theme.spacing(1),
    width: 36,
  },
}));

interface Props {
  devices: MedisanteDevice[];
  onExport: () => void;
}

const ExportToCsv = (props: Props) => {
  const { devices, onExport } = props;

  const prepareExport = () => {
    let data = 'data:text/csv;base64,';
    const items = devicesInCSVFormat(devices);
    return data + btoa(items);
  };

  const classes = useStyes();
  return (
    <>
      <MenuItem className={classes.menu}>
        <a
          download="devices.csv"
          onClick={onExport}
          href={prepareExport()}
          className={classes.btn}
        >
          <DownloadIcon className={classes.icon} /> Export to .CSV
        </a>
      </MenuItem>
    </>
  );
};

export default ExportToCsv;
